import { RouteConfig } from 'vue-router';

const routes: Array<RouteConfig> = [
	{
		path: '',
		component: () => import('@/views/volontari/VolontariList.vue'),
		meta: {
			title: 'volunteers',
			acl: 'section.volontari'
		}
	},
	
];

export default routes;